import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext, AuthContexType } from "../context/AuthContext";
import { Slide, toast } from "react-toastify";

import moment from "moment";

const Lock = () => {
  const { setUserToken } = useContext(AuthContext) as AuthContexType;
  const navigate = useNavigate();

  const [pincode, setPincode] = useState<string>("");
  const [dateTime, setDateTime] = useState<string>("");

  const handleFormSubmit = (e: any) => {
    e.preventDefault();
    if (pincode === process.env.REACT_APP_PIN_CODE) {
      sessionStorage.setItem(
        "sess",
        JSON.stringify({
          date: moment().format(),
          expiry: moment().add(1, "hours").format(),
        })
      );
      setUserToken(true);
      //navigate("/dashboard");
    } else {
      toast.warn("Incorrect pincode", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Slide,
      });
      setPincode("");
    }
  };

  useEffect(() => {
    let timer = setInterval(
      () => setDateTime(new Date().toLocaleString()),
      1000
    );
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <>
      <div className="container position-sticky z-index-sticky top-0">
        <div className="row">
          <div className="col-12">
            <nav className="navbar navbar-expand-lg blur border-radius-lg top-0 z-index-3 shadow position-absolute mt-4 py-2 start-0 end-0 mx-4">
              <div className="container-fluid ps-2 pe-2">
                <a
                  className="navbar-brand font-weight-bolder ms-lg-0 "
                  href="../../../pages/dashboards/analytics.html"
                >
                  <img
                    height={40}
                    src="https://getfluidapps.com/wp-content/uploads/2025/02/fluidapps-logo-nbg.png"
                    className="navbar-brand-img"
                    alt="main_logo"
                  ></img>
                </a>
                <div
                  className="collapse navbar-collapse w-100 pt-3 pb-2 py-lg-0"
                  id="navigation"
                >
                  <ul className="navbar-nav navbar-nav-hover mx-auto">
                    &nbsp;
                  </ul>
                  <ul className="navbar-nav d-lg-block d-none text-center">
                    <li className="nav-item">
                      <span className="text-dark">{dateTime}</span>
                      </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <main className="main-content  mt-0">
        <div
          className="page-header align-items-start min-vh-100"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1511447333015-45b65e60f6d5?q=80&w=2155&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')`,
            backgroundSize: "cover",
          }}
        >
          <span className="mask bg-gradient-dark opacity-5"></span>
          <div className="container my-auto">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-7 mx-auto">
                <div className="card">
                  <div className="card-body text-center">
                    <h4 className="mb-0 fw-bolder">Welcome</h4>
                    <p className="mb-4">
                      Please enter PIN code.
                    </p>
                    <form onSubmit={handleFormSubmit}>
                      <div className="input-group input-group-dynamic">
                        <label className="form-label">PIN Code</label>
                        <input
                          className="form-control text-center"
                          autoComplete="false"
                          maxLength={8}
                          type="password"
                          placeholder=""
                          value={pincode}
                          onChange={(e) => setPincode(e.currentTarget.value)}
                        />
                      </div>
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-lg bg-gradient-dark mt-4 mb-0"
                        >
                          Unlock
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Lock;
